import {ChangeDetectionStrategy, Component, HostBinding, Input, Optional} from '@angular/core';
import {coerceBooleanPrimitive} from '@atlas-angular/cdk/coercion';
import {FormElementComponent} from '@maia/forms';

/**
 * @ngModule SwitchesModule
 */
@Component({
  selector: 'maia-checkbox-group',
  template: '<ng-content></ng-content>',
  styleUrls: ['./checkbox-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxGroupComponent {
  @coerceBooleanPrimitive()
  @Input()
  @HostBinding('class.maia-checkbox-group--horizontal')
  @HostBinding('class.p-maia-checkbox-group--horizontal')
  public horizontal = false;

  public constructor(@Optional() parent?: FormElementComponent) {
    if (parent != null) {
      parent.extraPadding = true;
      parent.hideOptionalIndicator = true;
    }
  }
}
